<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2c"><a id="page_ix"></a><a id="map"></a><strong><em>Maps</em></strong></h2>
<p class="tocy"><span href="#/xhtml/frontm02#map1" title="Link target outside of Sample">1. The Philippines Area</span></p>
<p class="tocy"><span href="#/xhtml/chapter10#map2" title="Link target outside of Sample">2. Approach of the Nishimura and Shima forces</span></p>
<p class="tocy"><span href="#/xhtml/app01#map3" title="Link target outside of Sample">3. Battle of Surigao Strait, general main action</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// maps.vue?5ae46195